'use strict';

angular.module('atex.dam').controller('DamSortWidgetController', [ '$rootScope', '$scope', 'UIConfigurationService', function($rootScope, $scope, UIConfigurationService) {
  UIConfigurationService.fields("sort-form", "desk-sort-form").then(function (_result) {
    if(_result) {
      $rootScope.sortArray = _result;
    }
  });

  $scope.sortChanged = function (val) {
    if ($scope.selectSortCallBack) {
      $scope.selectSortCallBack({
        'value': val
      });
    }
  };
  $scope.sortOrderChanged = function (val) {
    if ($scope.selectSortOrderCallBack) {
      $scope.selectSortOrderCallBack({
        'value': val
      });
    }
  };
}]);

angular.module('atex.dam').directive('damSortWidget', function() {
  return {
    restrict: 'E',

    templateUrl: 'js/dam/widgets/dam-sort-widget/dam-sort-widget.html',

    replace: true,

    scope: {
      currentSortValue: '=',
      currentSortOrderValue: '=',
      selectSortCallBack: '&',
      selectSortOrderCallBack: '&',
      disableSortOrder: '=',
      label: "@"
    },

    controller: 'DamSortWidgetController',

    link: function (scope, element, attrs) {
    }
  };
});